import { useState } from "react";
import { subscriptionStyle, LOGO_SRC } from "./sharedStyle";

function getErrorFromQuery() {
  const err = new URLSearchParams(window.location.search).get("error");
  if (err === "expired") return "That sign-in link expired or was already used. Enter your email below to get a new one.";
  if (err === "server") return "Something went wrong verifying that link. Please try again.";
  if (err === "invalid") return "That sign-in link isn't valid. Enter your email below to get a new one.";
  return null;
}

export default function AccessPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [linkError] = useState(getErrorFromQuery());

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const res = await fetch("/api/subscription-access", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setMessage(data.message || "If that email has a weekly basket with us, check your inbox for a sign-in link.");
    } catch {
      setMessage("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="gg-app">
      <style>{subscriptionStyle}</style>
      <header className="gg-header">
        <div className="gg-logo"><img src={LOGO_SRC} alt="Grind and Gather" /></div>
        <a href="mailto:grindgather@gmail.com" className="gg-contact-link">Get in Touch</a>
      </header>

      <div className="gg-page">
        <h1>Access My Account</h1>
        <p>Enter the email you used to sign up for your weekly basket, and we'll send you a sign-in link.</p>

        {linkError && <div className="gg-error">{linkError}</div>}

        {message ? (
          <div className="gg-success">{message}</div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="gg-form-group">
              <label className="gg-form-label">Email Address</label>
              <input
                className="gg-form-input"
                type="email"
                placeholder="sara@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button className="gg-btn" type="submit" disabled={submitting}>
              {submitting ? "Sending…" : "Send Sign-In Link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
